import client from "../../../api/client";

export default async function getPropertyTypes() {
  const response = await client.get("/master/property-types");
  return response.data;
}